import React from 'react';
import { LinkText } from '@/components/atoms';

const LinkTextWrapper = ({ text, id, onClick }) => (
  <div className="link-text-wrapper">
    <LinkText text={text} id={id} handleClick={onClick} />
  </div>
);

export default LinkTextWrapper;